import { ITableColumn, DataTableDefaultCellTemplates, DataTableEventArgs, DataTableState, Icon } from "../../../../components";
import LookupService from "../../../../Services/LookupService";
import { SelectOption } from "../../../../shared/components/input/SelectOption";
import { useConfirmationModalContext } from "../../../../shared/components/ModalConfirmationContext";
import { CommonUtility } from "../../../../Services/CommonUtility";

export default class CustomerPolicyLocationService {
    private handleRowExpandToggle(
        dtEventArgs: DataTableEventArgs,
        onRowClick: any,
        onCancelClick: () => void
    ) {
        const { rowData, dataTableState, eventData } = dtEventArgs;
        const { rowsState } = dataTableState;
        const rowKey = rowData[dataTableState.dataTable.keyColumnName];
        let currentRowState = rowsState[rowKey];
        if (!eventData.target?.classList?.contains('chevron-disabled')) {
            if (!currentRowState) {
                currentRowState = { expanded: eventData.expand };
            } else {
                currentRowState = { ...currentRowState, expanded: eventData.expand };
            }

            if (!currentRowState.expanded && !dataTableState.dataTable.isFormSaved) {
                rowsState[rowKey] = { expanded: true };
                dataTableState.dataTable.setExpandedRowId(rowKey);
                rowsState[rowKey] = { expanded: false };
                dataTableState.dataTable.setExpandedRowId(rowKey);
            }
            rowsState[rowKey] = { expanded: currentRowState.expanded };

            dataTableState.dataTable.setExpandedRowId(
                currentRowState.expanded ? rowKey : null
            );

            if (currentRowState.expanded) {
                onRowClick(rowData, dtEventArgs.column);
            } else {
                onCancelClick();
            }
        }
        else {
            eventData.preventDefault();
        }
    }
  getLocationTableColumns = (onRowClick: any, onLocationSelect: any,  onCancelClick: () => void, onRowDeleteClick?: any, selectedLocationId?: string, tabIndex?: number): ITableColumn[] => {
    const modalContext = useConfirmationModalContext();
    return [
      {
        // key: "radioSelect",
        // title: "selectLocation",
        width: "40px",
        cellTemplate: (rowData) => {
          return (
            <div className="d-flex justify-content-center">
              <input
                type="radio"
                name="locationSelection"
                checked={rowData.id === selectedLocationId}
                onChange={() => onLocationSelect(rowData)}
                className="location-radio-select" 
              />
            </div>
          );
        },
        cellTdClassName: "radio-select-cell-td",
      },
      {
        tabIndex: tabIndex,
        width: "40px",
        cellTemplate: DataTableDefaultCellTemplates.RowExpander.CellTemplate,
        cellClickHandler: async (dtEventArgs: DataTableEventArgs) => {
            this.handleRowExpandToggle(dtEventArgs, onRowClick, onCancelClick);
          },
        onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
            const { eventData } = dtEventArgs;
            if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
                eventData.expand = true;
                  this.handleRowExpandToggle(dtEventArgs, onRowClick, onCancelClick);
              }
          },
        cellTdClassName: "expander-cell-td",
      },
      {
        header: "Location Number",
        field: "locationNumber",
        width: "15%",
        cellTemplate: (rowData) => <span>{rowData.locationNumber}</span>,
      },
      {
        header: "Address Line 1",
        field: "address1",
        width: "20%",
        cellTemplate: (rowData) => <span>{rowData.address1}</span>,
      },
      {
        header: "Address Line 2",
        field: "address2",
        width: "20%",
        cellTemplate: (rowData) => <span>{rowData.address2}</span>,
      },
      {
        header: "City",
        field: "city",
        width: "15%",
        cellTemplate: (rowData) => <span>{rowData.city}</span>,
      },
      {
        header: "State",
        field: "state",
        width: "10%",
        cellTemplate: (rowData) => <span>{rowData.state}</span>,
      },
      {
        header: "Zip Code",
        field: "zipCode",
        width: "10%",
        cellTemplate: (rowData) => {
          const formattedZip = rowData.zipCode ? CommonUtility.zipCodeFormat(rowData.zipCode) : rowData.zipCode;
          return <span title={formattedZip}>{formattedZip}</span>;
        },
      },
      {
        tabIndex: tabIndex,
        width: "5%",
        cellTemplate: DataTableDefaultCellTemplates.DeleteCellTemplate.CellTemplate,
          cellClickHandler: (dtEventArgs: DataTableEventArgs) => onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column),
          onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
              const { eventData } = dtEventArgs;
              if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
                  onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column);
              }
          }
      },
    ];
  };

  getUSStates = async (): Promise<SelectOption[]> => {
    const stateUSList = await LookupService.fetchUSStates();
       let stateUSOptions = stateUSList ? stateUSList.map(item => {
            return {
                label: item.lookupValue,
                value: item.lookupCode,
                isInactive: false
            }
        }) : [];
    return stateUSOptions;
  }
}